module.exports = __webpack_public_path__ + "static/media/Tread-life-warranty-badge.83bc93ac.svg";